import { EProductTourType } from '@constants';
import { create } from 'zustand';

interface ManualProductTourState {
  activeTour: EProductTourType | null;
  startTour: (tourType: EProductTourType) => void;
  clearTour: () => void;
}

export const useManualProductTour = create<ManualProductTourState>(set => ({
  activeTour: null,
  startTour: tourType => set({ activeTour: tourType }),
  clearTour: () => set({ activeTour: null })
}));
